module.exports = __webpack_public_path__ + "spa_static_mobile/img/EquipmentInstallation.2942a035.png";